const DEFAULT_DEV_API_URL = 'http://localhost:4000/api';

function resolveApiUrl() {
  const buildTime = process.env.REACT_APP_API_URL;

  // In development we often run UI and API on different origins.
  if (process.env.NODE_ENV === 'development') {
    return buildTime || DEFAULT_DEV_API_URL;
  }

  // In non-dev, prefer same-origin /api to avoid accidental staging/prod mismatch
  // (CRA env vars are baked into the build and are easy to misconfigure).
  if (typeof window !== 'undefined') {
    const origin = window.location.origin;

    if (!buildTime) return `${origin}/api`;

    // Allow relative paths like "/api".
    if (buildTime.startsWith('/')) return buildTime;

    try {
      const u = new URL(buildTime);
      if (u.origin !== origin) return `${origin}/api`;
      return buildTime;
    } catch {
      return `${origin}/api`;
    }
  }

  return buildTime || DEFAULT_DEV_API_URL;
}

const API_URL = resolveApiUrl();

// TODO: get from environment variable
const SHORT_CODE = '(513) 750-9622';

export default { API_URL, SHORT_CODE };
